import {
  LogoList,
  SubTitle,
  Title,
  Wrapper,
  Image,
} from '@/components/organisms/passTitle/PassTitle.styled';
import { TELECOM } from '@/const';

const PassTitle = () => {
  let telecomList = [...TELECOM];
  return (
    <Wrapper>
      <LogoList>
        {telecomList.map((telecom: string) => (
          <Image key={telecom} src={`/logo_${telecom}_small.svg`} alt={telecom} loading="lazy" />
        ))}
      </LogoList>
      <Title>하나로 모인 나의 혜택!</Title>
      <SubTitle>
        <Image src={`/pass_logo.svg`} alt="pass" loading="lazy" />
        금융
      </SubTitle>
    </Wrapper>
  );
};
export default PassTitle;
